// src/Component/hooks/useDeleteImage.js
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin'; // Pastikan path ini benar

/**
 * useDeleteZakat adalah custom hook yang digunakan untuk menghapus data zakat dari backend.
 * @returns { Object } - Mengembalikan fungsi deleteZakat, serta status loading dan error.
 */
const useDeleteInformasi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk menghapus zakat di backend.
   * @param { number } id - ID gambar yang akan dihapus.
   * @returns { Promise<boolean> } - Mengembalikan true jika berhasil, false jika gagal.
   */
  const deleteInformasi = async (id) => {
    setLoading(true);
    setError(null);

    try {
      if (!endpoints.informasi || typeof endpoints.informasi.delete !== 'function') {
        throw new Error('endpoints.informasi.delete is not defined');
      }
      const candidateEndpoints = (Array.isArray(endpoints.informasi.delete(id))
        ? endpoints.informasi.delete(id)
        : [endpoints.informasi.delete(id)]).filter(Boolean);
      let lastError = null;

      for (const endpoint of candidateEndpoints) {
        try {
          const response = await api.delete(endpoint, {
            headers: {
              'Content-Type': 'application/json',
            },
          });

          if (response.status === 200 || response.status === 204) {
            return true;
          }
        } catch (err) {
          lastError = err;

          if (err?.response?.status !== 404) {
            throw err;
          }
        }
      }

      throw lastError || new Error('Endpoint delete informasi tidak ditemukan.');
    } catch (err) {
      console.error('Error deleting informasi:', err);
      setError(err.response?.data?.error || err.message || 'Terjadi kesalahan saat menghapus informasi.');
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { deleteInformasi, loading, error };
};

export default useDeleteInformasi;
